import React, { useContext, useEffect, useRef, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { 
    Box,
    ClickAwayListener,
    Fade,
    Popper,
    Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import GreenButton from '../buttons/GreenButton';


export default function ConfirmActionDialog(props) {

    const { clickAway, handleClick, open, message } = props

    return (
        <Popper
            id={open ? 'warning-popper' : undefined}
            open={open}
            transition
            disablePortal
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                zIndex: 100,
            }}
        >
        {({ TransitionProps }) => (
             <ClickAwayListener onClickAway={clickAway}>
                <Fade {...TransitionProps}>
                    <Box
                        width={'720px'}
                        height={'200px'}
                        display="flex"
                        flexDirection="column"
                        backgroundColor={'rgba(0,0,0,0.9)'}
                        sx={{
                            border: '2px solid rgba(50, 180, 65, 1)',
                            borderRadius: '8px'
                        }}
                    >
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'30px'}
                                sx={{flexDirection:'column'}}
                            >
                                <Typography color={'white'} component="span" variant="h6" align="center">
                                    {message ?? "Are You Sure You Want To Continue?"}
                                </Typography>
                            </Box>
                            <Box
                                width={'100%'}
                                display={'flex'}
                            >
                                <Box
                                    width={'100%'}
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    px={3}
                                >
                                    <WarningIcon style={{fill: "rgba(200,200,0,0.8)"}} sx={{ fontSize: 20 }} />
                                    <Typography color={'rgba(200,200,0,0.8)'} variant="h7" align="center">
                                        {`By continuing, you understand the implications of this action and accept all liability associated with performing it.`}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'auto'}
                                marginBottom="30px"
                            >                                
                                <GreenButton variant='contained' onClick={handleClick} text='Continue' />
                                
                            </Box>
                        
                    </Box>
                </Fade>
             </ClickAwayListener>
        )}
        </Popper>
    )}